import { useEffect, useState } from "react";

export type BsSize = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

const bootstrapSizing : {[key in BsSize] : number} = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
  };


export function useWindowDimensions() {
    const [width, setWidth] = useState<number>();
    const [height, setHeight] = useState<number>();
    const [bootstrapSize, setBootstrapSize] = useState<BsSize>();

    function metBreakpoint(bsSize : BsSize){
      return bootstrapSize !== undefined && bootstrapSizing[bsSize] <= bootstrapSizing[bootstrapSize];
    }

    /**
     * 
     * @param choices an object mapped between Bootstrap size and the desired return value
     * @returns the value mapped to the largest breakpoint that has been met
     */
    function metBreakpoints<T>(choices : Partial<{[key in BsSize] : T}>) : T | undefined{
      for(const key of Object.keys(bootstrapSizing).reverse()){
        if(!choices[key as BsSize]) continue;
        if(metBreakpoint(key as BsSize)) return choices[key as BsSize];
      }
      return undefined;
    }

    useEffect(() => {
      function handleResize(){
        if(window){
          const w = window.innerWidth;
          setWidth(window.innerWidth);
          setHeight(window.innerHeight);
          let bsSize : BsSize = "xs";
          if(w >= bootstrapSizing.xxl){
            bsSize = "xxl";
          }else if(w >= bootstrapSizing.xl){
            bsSize = "xl";
          }else if(w >= bootstrapSizing.lg){
            bsSize = "lg"
          }else if(w >= bootstrapSizing.md){
            bsSize = "md";
          }else if(w >= bootstrapSizing.sm){
            bsSize = "sm"
          }
          setBootstrapSize(bsSize);
        }
      }
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    },[]);

    return {
      width,
      height,
      bootstrapSize,
      metBreakpoint,
      metBreakpoints
    };
  }